import { useQueryClient } from "react-query";

import renderAlertConfirmationModal, { AlertConfirmationModal } from "../alert-confirmation-modal";

import { useModalContext } from "../../../Contexts/ModalContext";

import { useDeletePayee } from "../../../CustomHooks/Mutations";

import { dispatchAPIErrorToast } from "../../../Utils/helpers";
import { APIQueryKeys, modalVariants } from "../../../Utils/constants";

export default function renderDeletePayee(modalContext, payee) {
  const { updateModalComponent, pushModalStack, setModalVariant, setModalTitle, setModalClassName } = modalContext;

  updateModalComponent(() => <DeletePayee payee={payee} />);
  pushModalStack(() => renderDeletePayee(modalContext));
  setModalVariant(modalVariants.promptDialog);
  setModalTitle("");
  setModalClassName("");
}

const DeletePayee = ({ payee }) => {
  const queryClient = useQueryClient();

  const modalContext = useModalContext();
  const { popModalStack, onModalClose } = modalContext;

  const { isLoading: isDeletingPayee, mutate: DeletePayee } = useDeletePayee({
    onSuccess: () => {
      queryClient.refetchQueries(APIQueryKeys.payeeList);
      onModalClose();
    },
    onError: (err) => {
      if (err?.response?.status === 422) {
        renderAlertConfirmationModal(modalContext, {
          title: "Unable to delete payee",
          description: err?.response?.data?.error,
          CTAButtonText: "Got it",
          onCTAButtonClick: onModalClose,
          hideSecondaryCTAButton: true,
        });
      } else {
        dispatchAPIErrorToast({ message: err?.response?.data?.error, key: "deletePayee" });
      }
    },
  });

  return (
    <AlertConfirmationModal
      variant="alert-error"
      title="Delete Payee?"
      description={`${payee?.name} will be removed from your saved payees. You can add them again anytime.`}
      CTAButtonText="Confirm"
      onCTAButtonClick={() => DeletePayee({ counter_party_id: payee.counter_party_id })}
      isCTALoading={isDeletingPayee}
      secondaryCTAButtonText="Cancel"
      onSecondaryCTAButtonClick={() => popModalStack(1)}
    />
  );
};
